import _ from 'lodash';
import config from './default';

const test = _.cloneDeep(config);

test.googleAnalyticsCode = 'UA-110840836-2';

export default test;
